import AuthBgBanner from "public/images/rangers/new-york-rangers-celebrations.jpg";
import { howItWorks, faqs, CheckoutTerms } from "../rangers/helpers";
import { routes } from "@/global/routes";
import SeatMap3dPreview from "public/images/rangers/rangers_3d_venue.png";
import { TeamConfig } from "../types";
import Logo from "public/images/athletics/athletics_logo.jpg";
import { vendorUUIDs } from "../../constants";

// image sizes
// featured game card image : 350x180

const config: TeamConfig = {
  teamSchema: "flex_sandbox_athletics",
  browserTitle: "Athletics Flex",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "Flex Sandbox",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-00045-rangers-sec",
    mapId: "main",
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.purchaseSeats,
  },

  // disabled routes
  disabledRoutes: [routes.giftCard],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: true,
  isCrowdHandlerEnabled: false,
  inventoryType: "SECTION-LEVEL",

  // purchase seat configs
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: true,
    isPerksEnabled: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  refreshInventoryWhenEventClick: false,
  platform: vendorUUIDs.ticketmaster,
  oktaIssuer: "",
  oktaClientId: "",
  isSaveCardAllowed: true,

  // urls
  accountManagerUrl: "https://bp.mlb.com/Wallet",

  // images
  images: {
    findGamesBannerImage:
      "https://ss-leagues.s3.amazonaws.com/NHL/Rangers%2023-24%20Assets/NYR%20Banner%201486x148.jpg",
    authBackgroundImage: AuthBgBanner.src,
    checkoutStatusPageImage: AuthBgBanner.src,
    logoImage: Logo.src + "?width=84&height=66",
    logoNameImage: "",
    faviconImage: Logo.src,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  colors: {
    primary: "#005189",
  },

  howItWorks,
  faqs,

  uiConfigs: {
    bannerImage: {
      title: "Choose Your Games",
      isBackgroundBasedBanner: true,
    },
    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },
    bottomBar: {
      showGameSelectionProgress: false,
    },
  },

  languages: {
    topNavMenuItems: "",
    checkoutTermsAndCondition: <CheckoutTerms />,
    registrationTermsAndCondition: <CheckoutTerms />,
    purchaseSeats: null,
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutServiceNote:
      "<b>SERVICE NOTE:</b> At this time you may need to wait 24 hours between transactions to see the correct amount of Credit Available. We apologize for any inconvenience caused and assure you that we're actively resolving this issue. Thank you for your patience.",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster account above.",
        },
        logout: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
        },
        success: {
          description: "has been added to to your account!",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
